const MIN_SCALE = 12 / 96

export function fitScale(measured: number, available: number): number {
  if (measured <= 0) {
    return 1
  }
  return Math.max(MIN_SCALE, Math.min(1, available / measured))
}

export function amountRowGeometry(measured: number, available: number) {
  const scale = fitScale(measured, available)
  return {
    scale,
    // Keep the left edge visible even when the readability floor is reached.
    translateX: Math.max(0, (available - measured * scale) / 2),
  }
}
